module.exports = __webpack_public_path__ + "static/media/de-angelo-work-sample.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designer-profiles/de-angelo-work-sample.png
// module id = 524
// module chunks = 0